{
  "Sign In - EventLive": "Iniciar sessão - EventLive",
  "Forgot Password - EventLive": "Esqueci-me da palavra-passe - EventLive",
  "Password Restore Link Sent - EventLive": "Link de recuperação da palavra-passe enviado - EventLive",
  "How to Go Live": "Como transmitir em direto",
  "Multi-Camera": "Multicâmara",
  "Download everything": "Transferir tudo",
  "Set a New Password - EventLive": "Criar uma nova palavra-passe - EventLive",
  "Are you sure?": "Tem a certeza?",
  "Could not load data. Please check your internet connection. Ensure the timezone, date and time on your device are correct.": "Não foi possível carregar os dados. Verifique a sua ligação à Internet. Certifique-se de que o fuso horário, a data e a hora do seu dispositivo estão corretos.",
  "Couldn't save your profile": "Não foi possível guardar o seu perfil",
  "Couldn't sign you in from this link": "Não foi possível iniciar sessão com este link",
  "Please sign in to continue.": "Inicie sessão para continuar.",
  "Couldn't save your changes": "Não foi possível guardar as suas alterações",
  "Download EventLive for Mac": "Transferir o EventLive para Mac",
  "Download for": "Transferir para",
  "Team invite - EventLive": "Convite para a equipa - EventLive"
}
